__turbopack_context__.v({
  "amt_ans_togglebtn_wrapper": "rwlNya_amt_ans_togglebtn_wrapper",
  "amt_togglebtn_wrapper": "rwlNya_amt_togglebtn_wrapper",
  "focus_class": "rwlNya_focus_class",
  "medical_gatekeeper_toggle_btn": "rwlNya_medical_gatekeeper_toggle_btn",
  "next_year_renwal": "rwlNya_next_year_renwal",
  "policy_togglebtn_wrapper": "rwlNya_policy_togglebtn_wrapper",
  "review_auto_renewal_togglebtn_wrapper": "rwlNya_review_auto_renewal_togglebtn_wrapper",
  "secondary": "rwlNya_secondary",
  "toggle_btn": "rwlNya_toggle_btn",
});
